// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"lB-z","slideIn":"mB-z"};